<div class="pt-10 px-10 pb-10">
  <div class="flex justify-between items-start mb-4">
    <h1 class="text-2xl font-bold">Consultores</h1>
    <button
      type="button"
      class="bg-primary text-white py-2 px-4 rounded-lg flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
      (click)="syncConsultants()"
      [disabled]="!canSync || isSyncing"
      [matTooltip]="
        !canSync
          ? 'Você não tem permissão para sincronizar'
          : isSyncing
          ? 'Sincronização em andamento...'
          : 'Sincronizar com Omie'
      "
    >
      <mat-icon class="mr-2" [class.animate-spin]="isSyncing">sync</mat-icon>
      {{ isSyncing ? 'Sincronizando...' : 'Sincronizar com o Omie' }}
    </button>
  </div>

  <div class="bg-white shadow rounded-lg p-4 mb-4">
    <div class="flex gap-4">
      <div class="relative flex-1">
        <mat-icon
          *ngIf="!isLoading"
          class="absolute left-2 top-2 text-gray-500"
          >search</mat-icon
        >
        <div
          *ngIf="isLoading"
          class="absolute left-2 top-2 flex items-center justify-center"
        >
          <mat-spinner [diameter]="20" color="primary"></mat-spinner>
        </div>
        <input
          type="text"
          placeholder="Buscar consultores..."
          class="w-full p-2 pl-10 border border-gray-200 rounded-lg input-field-focus"
          [formControl]="searchControl"
          (keydown)="onSearchKeydown($event)"
        />
      </div>
    </div>
  </div>

  <div>
    <ngx-datatable
      class="material"
      [rows]="consultants"
      [columns]="columns"
      [columnMode]="ColumnMode.flex"
      [headerHeight]="50"
      [footerHeight]="50"
      [rowHeight]="'auto'"
      [externalPaging]="true"
      [count]="page.count"
      [offset]="page.page"
      [limit]="page.pageSize"
      (page)="onPage($event)"
      (sort)="onSort($event)"
      [messages]="{
        emptyMessage: isLoading
          ? 'Buscando resultados...'
          : 'Nenhum consultor encontrado.'
      }"
    >
      <ngx-datatable-footer>
        <ng-template
          ngx-datatable-footer-template
          let-rowCount="rowCount"
          let-pageSize="pageSize"
          let-curPage="curPage"
        >
          <div class="flex items-center justify-between w-full px-4">
            <span class="text-sm text-gray-600">
              Mostrando {{ getStartIndex() }} a {{ getEndIndex() }} de
              {{ page.count }} resultados
            </span>
            <datatable-pager
              [pagerLeftArrowIcon]="'datatable-icon-left'"
              [pagerRightArrowIcon]="'datatable-icon-right'"
              [pagerPreviousIcon]="'datatable-icon-prev'"
              [pagerNextIcon]="'datatable-icon-skip'"
              [page]="curPage"
              [size]="pageSize"
              [count]="rowCount"
              (change)="onPage($event)"
            >
            </datatable-pager>
          </div>
        </ng-template>
      </ngx-datatable-footer>

      <ngx-datatable-column
        prop="nome"
        name="Consultor"
        [headerClass]="'text-xs'"
        [cellClass]="'cell-truncate'"
        [flexGrow]="4"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex items-center min-w-0">
            <img
              [src]="row.avatarUrl"
              alt="user"
              class="w-8 h-8 rounded-full mr-2 flex-shrink-0 self-center"
              onerror="this.src='assets/img/profile_placeholder.png'"
            />
            <span
              class="text-sm font-semibold text-primary-dark truncate"
              [title]="row.nome | capitalizeWords"
              >{{ row.nome | capitalizeWords }}</span
            >
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        prop="email"
        name="E-mail"
        [headerClass]="'text-xs'"
        [cellClass]="'cell-truncate'"
        [flexGrow]="4"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span class="text-sm text-primary-gray truncate" [title]="row.email">
            {{ row.email }}
          </span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Roteiros Atribuídos"
        [headerClass]="'text-xs'"
        [flexGrow]="3"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <app-badge variant="blue">{{ getAssignedRoutesLabel(row) }}</app-badge>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Rota Atual"
        [headerClass]="'text-xs'"
        [flexGrow]="3"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <app-badge *ngIf="getCurrentRoute(row) !== '-'" variant="blue">
            {{ getCurrentRoute(row) }}
          </app-badge>
          <span *ngIf="getCurrentRoute(row) === '-'" class="text-sm text-gray-400">
            -
          </span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Em Atividade?"
        [headerClass]="'text-xs'"
        [flexGrow]="2"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <app-badge [variant]="row.active ? 'green' : 'yellow'">
            {{ row.active ? 'Ativo' : 'Inativo' }}
          </app-badge>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Ações"
        [headerClass]="'text-xs'"
        [flexGrow]="2"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-nowrap pr-2">
            <button
              type="button"
              class="text-primary hover:text-primary-dark cursor-pointer"
              (click)="navigateToDetail(row.id)"
              matTooltip="Ver detalhes"
            >
              <span class="material-symbols-outlined small-icon">
                open_in_new
              </span>
            </button>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
  <div class="h-24"></div>
</div>
